// extracted by mini-css-extract-plugin
module.exports = {"Table":"PageTemplate_Table__3hoVR"};